import React, { useEffect } from 'react';

const sections = [
  {"title": "Política de cookies", "body": ["Responsable: Áncora Automations, automatiza@ancoraautomations.es. Solo usamos analítica y publicidad con tu consentimiento, separado por finalidad. Rechazar permite navegar igual. Google y Microsoft no se cargan antes de elegir.", "Analítica: Google Analytics 4 (_ga y _ga_BNR322B8R3, hasta 2 años) mide visitas y eventos; Microsoft Clarity (_clck, hasta 1 año, y _clsk, hasta 1 día) analiza la navegación y las sesiones. Publicidad: Google Ads (_gcl_au, hasta 90 días) mide conversiones y permite personalizar anuncios si autorizas esta finalidad.", "Guardamos tu elección en el almacenamiento local del navegador (ancora-cookie-consent-v1) durante 6 meses. Este almacenamiento técnico es necesario para recordar tu decisión. No activamos opciones por defecto. Puedes aceptar, rechazar o guardar una selección en el aviso, y cambiarla o retirarla desde «Configurar cookies» en el pie de cualquier página. Al retirar el permiso borramos las cookies de estos servicios accesibles desde nuestro dominio y recargamos la página para detenerlos.", "Google Ireland Limited y Microsoft Ireland Operations Limited reciben datos de navegación cuando autorizas sus servicios. Pueden tratar datos fuera del Espacio Económico Europeo con las garantías descritas en sus políticas. Consulta https://policies.google.com/privacy y https://privacy.microsoft.com/es-es/privacystatement, y la información sobre cookies en https://policies.google.com/technologies/cookies. Puedes ejercer tus derechos en el correo de privacidad y reclamar ante la AEPD (https://www.aepd.es)."]},
  {
    title: '1. Responsable del tratamiento',
    body: [
      'El responsable del tratamiento es Ancora Automations, empresa dedicada a automatizaciones con inteligencia artificial para atención al cliente, reservas, ventas, marketing e integraciones de negocio.',
      'Contacto de privacidad: automatiza@ancoraautomations.es · Teléfono de contacto: +34 614 046 352 · Sitio web: https://www.ancoraautomations.es/',
    ],
  },
  {
    title: '2. Aplicación y servicios cubiertos',
    body: [
      'Esta política cubre la web de Ancora Automations y las aplicaciones o integraciones que Ancora Automations conecta con servicios de Meta, incluyendo WhatsApp Business Platform, Instagram, páginas de Facebook y herramientas relacionadas para atender mensajes, gestionar solicitudes, coordinar reservas, dar soporte y operar automatizaciones contratadas por clientes. También cubre la integración opcional con Google Calendar, que permite a los profesionales de los negocios que usan nuestros servicios mostrar sus citas en su propio calendario de Google.',
    ],
  },
  {
    title: '3. Datos personales que podemos tratar',
    list: [
      'Datos de contacto: nombre, empresa, correo electrónico, teléfono y canal preferido de comunicación.',
      'Mensajes y contenido enviado voluntariamente por WhatsApp, Instagram, formularios web, email u otros canales conectados.',
      'Datos necesarios para prestar el servicio solicitado: solicitudes de información, reservas, incidencias, preferencias comunicadas por el usuario y estado de conversaciones comerciales o de soporte.',
      'Identificadores técnicos o de canal facilitados por Meta o por el propio canal, como número de teléfono de WhatsApp, identificador de usuario/página, nombre de perfil público, fecha/hora del mensaje y metadatos necesarios para entregar y responder comunicaciones.',
      'Datos técnicos básicos de uso de la web, como dirección IP, navegador, páginas visitadas y eventos de analítica cuando proceda.',
    ],
  },
  {
    title: '4. Finalidades del tratamiento',
    list: [
      'Responder solicitudes recibidas por la web, WhatsApp, Instagram, Facebook, email u otros canales.',
      'Prestar servicios de automatización, atención al cliente, gestión de reservas, seguimiento comercial, soporte e integraciones contratadas.',
      'Mantener el historial necesario para continuar conversaciones, evitar duplicados y mejorar la calidad del servicio.',
      'Enviar comunicaciones relacionadas con una solicitud, contrato, servicio activo o consentimiento otorgado.',
      'Proteger la seguridad de la aplicación, prevenir abuso, depurar incidencias técnicas y cumplir obligaciones legales.',
    ],
  },
  {
    title: '5. Base jurídica',
    body: [
      'Tratamos los datos cuando existe consentimiento del usuario, cuando el tratamiento es necesario para gestionar una solicitud o contrato, cuando existe interés legítimo en mantener la seguridad y continuidad del servicio, o cuando debemos cumplir obligaciones legales aplicables.',
    ],
  },
  {
    title: '6. Compartición de datos y encargados',
    body: [
      'Ancora Automations no vende datos personales. Podemos utilizar proveedores tecnológicos necesarios para prestar el servicio, como Meta/WhatsApp/Instagram, Google (Google Calendar), proveedores de hosting, correo electrónico, agenda, CRM, analítica, herramientas de automatización o servicios de inteligencia artificial. Estos proveedores actúan según sus propias condiciones y/o como encargados del tratamiento cuando corresponde, y solo se usan para las finalidades descritas.',
    ],
  },
  {
    title: '7. Integración con Google Calendar',
    body: [
      'Los profesionales de los negocios que usan la plataforma de Ancora Automations pueden conectar voluntariamente su cuenta de Google para que las citas que tienen asignadas aparezcan en su Google Calendar. La conexión es opcional y se puede retirar en cualquier momento.',
      'Datos de Google a los que accedemos. Con el permiso del profesional accedemos a la lista de sus calendarios, solo para que elija en cuál se guardan las citas, y a la dirección de la cuenta conectada, para mostrarla en el panel. En el calendario elegido creamos, actualizamos y eliminamos únicamente los eventos que corresponden a sus citas. No leemos, modificamos ni eliminamos ningún otro evento.',
      'Datos que enviamos a Google. Cada evento contiene el servicio, la fecha y la hora de la cita, y el nombre y teléfono del cliente. No incluimos correo electrónico, notas ni datos de salud, no añadimos invitados y no enviamos invitaciones.',
      'Finalidad y base jurídica. Mostrar al profesional su agenda en su propio calendario. Ancora Automations actúa como encargado del tratamiento por cuenta del negocio que contrata el servicio. La conexión requiere la autorización expresa del profesional en la pantalla de Google.',
      'Protección de los datos. Toda la comunicación con Google y con el panel viaja cifrada mediante HTTPS (TLS). Los tokens de acceso y de actualización, y el código de autorización temporal, se guardan cifrados en nuestra base de datos con cifrado autenticado (AES con HMAC-SHA256) y nunca se escriben en los registros. Solo el servidor de la aplicación puede descifrarlos, y únicamente para llamar a Google. El acceso al panel exige usuario y contraseña, cada profesional solo puede gestionar su propia conexión y los datos de cada negocio están separados de los de los demás. El acceso a la infraestructura está limitado al personal técnico autorizado de Ancora Automations. Pedimos a Google solo los permisos mínimos necesarios para esta función. Si se produjera una brecha de seguridad que afectara a estos datos, la notificaremos a la autoridad de control y, cuando corresponda, a las personas afectadas, en los plazos del RGPD.',
      'Conservación. Al desconectar, revocamos el acceso en Google y borramos los tokens. Los eventos ya creados permanecen en el calendario del profesional, que puede borrarlos. Si una cita se cancela o se elimina, retiramos su evento del calendario.',
      'Inteligencia artificial. Los datos obtenidos de las API de Google (la lista de calendarios, la dirección de la cuenta conectada y los identificadores de los eventos que creamos) no se envían a ningún proveedor de inteligencia artificial, no se incluyen en las instrucciones ni en las conversaciones de nuestros asistentes y no se usan para crear, entrenar ni mejorar modelos de inteligencia artificial, propios o de terceros. Los asistentes de inteligencia artificial de Ancora Automations, que usan servicios de OpenAI y Google Gemini para otras funciones como responder mensajes de clientes, no tienen acceso a esta integración.',
      'Uso limitado. Los datos obtenidos de las API de Google se usan solo para prestar esta función. No se venden, no se usan con fines publicitarios, no se usan para entrenar modelos de inteligencia artificial y no se ceden a terceros salvo obligación legal. El uso y la transferencia a cualquier otra aplicación de la información recibida de las API de Google se ajustarán a la Política de Datos de Usuario de los Servicios de API de Google (https://developers.google.com/terms/api-services-user-data-policy), incluidos los requisitos de Uso Limitado.',
      'Cómo retirar el acceso. Desde el panel, en «Google Calendar» → «Desconectar», o desde la cuenta de Google en https://myaccount.google.com/permissions.',
    ],
  },
  {
    title: '8. Conservación',
    body: [
      'Conservamos los datos durante el tiempo necesario para gestionar la relación, prestar el servicio solicitado, resolver incidencias, cumplir obligaciones legales y mantener registros razonables de seguridad. Cuando los datos dejan de ser necesarios, se eliminan o anonimizan de forma segura.',
    ],
  },
  {
    title: '9. Derechos de las personas usuarias',
    body: [
      'Puedes solicitar acceso, rectificación, supresión, oposición, limitación del tratamiento y portabilidad escribiendo a automatiza@ancoraautomations.es. Para proteger tu privacidad, podemos solicitar información adicional para verificar tu identidad antes de atender la solicitud.',
    ],
  },
  {
    title: '10. Eliminación de datos',
    body: [
      'Puedes solicitar la eliminación de tus datos en cualquier momento escribiendo a automatiza@ancoraautomations.es con el asunto “Solicitud de eliminación de datos”. También puedes consultar las instrucciones públicas en https://www.ancoraautomations.es/eliminacion-datos.html.',
    ],
  },
  {
    title: '11. Cambios en esta política',
    body: [
      'Podemos actualizar esta política para reflejar cambios legales, técnicos o de nuestros servicios. La versión vigente estará siempre disponible en esta URL pública.',
    ],
  },
];

export const PrivacyPolicy: React.FC = () => {
  useEffect(() => {
    const previousTitle = document.title;
    const description = 'Política de privacidad de Ancora Automations y de sus aplicaciones conectadas a Meta, WhatsApp, Instagram y Google Calendar.';
    const canonicalUrl = 'https://www.ancoraautomations.es/privacidad';
    document.title = 'Política de privacidad | Ancora Automations';

    let metaDescription = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    const previousDescription = metaDescription?.content;
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = description;

    let canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    const previousCanonical = canonical?.href;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = canonicalUrl;

    const openGraphTags = [
      { property: 'fb:app_id', content: '1864910794392369' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: canonicalUrl },
      { property: 'og:title', content: 'Política de privacidad | Ancora Automations' },
      { property: 'og:description', content: description },
      { property: 'og:image', content: 'https://www.ancoraautomations.es/og-image.png' },
      { property: 'og:image:secure_url', content: 'https://www.ancoraautomations.es/og-image.png' },
      { property: 'og:image:type', content: 'image/png' },
      { property: 'og:image:width', content: '1536' },
      { property: 'og:image:height', content: '1024' },
      { property: 'og:image:alt', content: 'Ancora Automations - automatizaciones con IA para atención, ventas y marketing' },
      { property: 'og:site_name', content: 'Ancora Automations' },
    ];

    const previousOpenGraphTags = openGraphTags.map(({ property, content }) => {
      let tag = document.querySelector<HTMLMetaElement>(`meta[property="${property}"]`);
      const created = !tag;
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      const previousContent = tag.content;
      tag.content = content;
      return { tag, created, previousContent };
    });

    return () => {
      document.title = previousTitle;
      if (metaDescription && previousDescription !== undefined) {
        metaDescription.content = previousDescription;
      }
      if (canonical && previousCanonical) {
        canonical.href = previousCanonical;
      }
      previousOpenGraphTags.forEach(({ tag, created, previousContent }) => {
        if (created) {
          tag.remove();
        } else {
          tag.content = previousContent;
        }
      });
    };
  }, []);

  return (
    <div className="legal-page pt-32 md:pt-36 pb-24 bg-[#f6f8f7]">
      <div className="container mx-auto px-4 max-w-4xl">
        <p className="text-sm font-bold text-[#087064] uppercase tracking-[0.2em] mb-4">Ancora Automations</p>
        <h1 className="legal-page__title text-4xl md:text-5xl text-[#10232d] mb-4">Política de Privacidad</h1>
        <p className="text-[#536970] mb-6">Última actualización: 5 de octubre de 2026</p>
        <p className="text-[#536970] mb-12 rounded-2xl border border-[#b9d8d0] bg-[#dceee9] p-5">
          Esta página describe cómo Ancora Automations trata los datos personales en su web y en sus aplicaciones conectadas a Meta, WhatsApp, Instagram y Google Calendar. La página es pública, no requiere inicio de sesión y pertenece a Ancora Automations.
        </p>
        <div className="prose prose-slate max-w-none">
          {sections.map((section) => (
            <section style={section.title === 'Política de cookies' ? { overflowWrap: 'anywhere' } : undefined} id={section.title === 'Política de cookies' ? 'cookies' : undefined} key={section.title} className="py-8 border-t border-[#d7e4e2]">
              <h2 className="text-xl font-bold text-[#10232d] mb-4">{section.title}</h2>
              {section.body?.map((paragraph) => (
                <p key={paragraph} className="text-[#536970] mb-3">{paragraph}</p>
              ))}
              {section.list && (
                <ul className="list-disc pl-6 mb-4 space-y-1 text-[#536970]">
                  {section.list.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              )}
            </section>
          ))}
        </div>
      </div>
    </div>
  );
};
